import {
  Button,
  Card,
  CardActionArea,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Icon,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Zoom,
} from "@mui/material";
import { ReactComponent as AttachmentAvatar } from "assets/Svgs/AttachmentHr.svg";
import { ReactComponent as DeleteSVG } from "assets/Svgs/delete.svg";

import i18n from "i18n/i18n";
import { useBoundStore } from "store/store";
import { categoryItems } from "utils/helper";

function UploadAttachmentModal(props: any) {

  const handleFileChange = (e: any) => {
    let file = e.target.files[0];
    
    props?.setTarget(e);
    props?.setFile(file);
    if (props.from === "backup") {
      props?.setOpenDialog(false);
      props?.setLoadingModal(true);
    }
  };

  const deleteFile = () => {
    props?.setTarget();
    props?.setFile();
  };

  const handleClose = () => {
    if (props.hasTitle) {
      props?.setTitle();
    }

    if (props.hasDescription) {
      props?.setDescription();
    }
    deleteFile();
    props?.onClose();
  };

  const formatfileName = (str: any, limit: any) => {
    let name = str?.split(".");
    if (name?.length > 1) {
      if (name[0].length > limit) {
        return name[0]?.substr(0, limit) + "... ." + name[name.length - 1]; // name upto limit character + extention
      } else {
        return name[0]?.substr(0, limit) + "." + name[name.length - 1];
      }
    } else {
      return name[0]?.substr(0, limit);
    }
  };

  const renderFileDetails = () => {
    return (
      <div className="fileDetails" style={{ pointerEvents: props.editMode ? "none" : "all" }}>
        <div className="detail">
          <div className="name"> { props.editMode ? props.title : props?.file?.name ? formatfileName(props?.file?.name, 25) : props.title}</div>
          <div className="size"> {props.editMode ? "" : ((props?.file.size / 1000)+ " KB" )}</div>
        </div>
        <div className="icon">
          <DeleteSVG onClick={deleteFile} />
        </div>
      </div>
    );
  };

  const lang: any = useBoundStore((state) => state.lang);

  let canChangeFile = props.file ? (props.file.size ? true : false) : true;

  return (
    <Dialog
      open={props?.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{ backdropFilter: "blur(4px)" }}
      TransitionComponent={Zoom}
      className="uploadAttachmentModal"
      fullWidth={true}
      maxWidth="xs"
    >
      {props.showHeader ? (
        <DialogTitle
          id="alert-dialog-title"
          sx={{ padding: "20px 0px 28px 24px" }}
        >
          {i18n(lang)?.upload_file}
        </DialogTitle>
      ) : (
        ""
      )}
      <DialogContent id="alert-dialog-description">
        <div className="uploadAttachmentWrapper">
         
          <input
            id="myInputDoc"
            style={{ display: "none" }}
            type={"file"}
            accept={props.allowedExts}
            onChange={handleFileChange}
          />
          <Card
             sx={{
              height: 70,
              backgroundColor: canChangeFile ? "transparent" : "#d3d3d361",
            }}
            variant="outlined"
            style={{ margin: "5px 0px" }}
          >
            
            <CardActionArea>
              {props?.file && props?.fromDoc ? (
                renderFileDetails()
              ) : (
                <label htmlFor="myInputDoc">
                  <CardHeader
                    sx={{
                      height: 70,
                      cursor: "pointer",
                    }}
                    className="NT_cardHeader"
                    avatar={
                      <Icon color="primary" className={""} style={{ marginBottom:"10px"}}>
                        <AttachmentAvatar />
                      </Icon>
                    }
                    title={i18n(lang)?.upload_attachment_title + "..."}
                  />
                </label>
              )}
            </CardActionArea>
          </Card>
         
        </div>

        {props?.hasTitle ? (
          <TextField
            id="outlined-basic"
            label={i18n(lang)?.display_name}
            variant="outlined"
            value={props.title}
            onChange={(e) => {
              props?.setTitle(e.target.value);
            }}
            sx={{ marginTop: 3 }}
            fullWidth
          />
        ) : (
          ""
        )}
        {props?.hasDescription ? (
          <TextField
            id="outlined-basic"
            label={
              i18n(lang)?.short_description + " (" + i18n(lang)?.optional + ")"
            }
            variant="outlined"
            value={props.description}
            onChange={(e) => {
              props?.setDescription(e.target.value);
            }}
            sx={{ marginTop: 3, marginBottom: 3 }}
            fullWidth
          />
        ) : (
          ""
        )}

        {/* {props?.hasCategory ? (
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {i18n(lang)?.category}
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={props?.category}
              label={i18n(lang)?.category}
              onChange={(e) => {
                props?.setCategory(e.target.value);
              }}
            >
              <MenuItem value={i18n(lang).all}>{i18n(lang)?.all}</MenuItem>
            </Select>
          </FormControl>
        ) : (
          ""
        )} */}

{props?.hasCategory ? (

        <FormControl fullWidth>
          <InputLabel id="kategorie-select-label">
            {i18n(lang).category}
          </InputLabel>
          <Select
            labelId="kategorie-select-label"
            id="kategorie-select"
            value={props?.attachmentCategory ? props?.attachmentCategory : ""}
            onChange={(e) => {
              props?.setAttachmentCategory &&
                props?.setAttachmentCategory(e.target.value.split("$")[0]);
            }}
            label={i18n(lang).category}
          >
            {categoryItems.map((selectedCategory: any) => (
              <MenuItem value={selectedCategory.id} key={selectedCategory.id}>
                {selectedCategory.category[lang]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
) : "" }

      </DialogContent>
      {props.showActions ? (
        <DialogActions sx={{ padding: "16px 26px" }}>
          <Button variant="text" className="lp125" onClick={handleClose}>
            {i18n(lang)?.button_cancel}
          </Button>
          {
            <Button
              variant="contained"
              className="lp125 has_disabled"
              style={{ backgroundColor: "var(--primary-color" }}
              onClick={() => {
                props?.handleSubmit(props.target);
              }}
              disabled={
                !props.editMode &&
                (props?.file === "" ||
                  props?.file === null ||
                  props?.file === undefined) || props?.attachmentCategory === ""
              }
            >
              {props.editMode ? i18n(lang)?.edit : i18n(lang)?.save}
            </Button>
          }
        </DialogActions>
      ) : (
        ""
      )}
    </Dialog>
  );
}

export default UploadAttachmentModal;
